/* Publish by EComposer at 2026-11-03 09:08:50*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sxcnlh2mgpm"]=  window.__ectimmers["ecom-sxcnlh2mgpm"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-sxcnlh2mgpm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-sxcnlh2mgpm', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-sxcnlh2mgpm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-mo3q8gy81fg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-mo3q8gy81fg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-mo3q8gy81fg', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-alnzrg9uzeq"]=  window.__ectimmers["ecom-alnzrg9uzeq"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-alnzrg9uzeq"]["0vhricq0y"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-alnzrg9uzeq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-alnzrg9uzeq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-alnzrg9uzeq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-shy09yn15h').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-shy09yn15h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-shy09yn15h', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}